module.exports = __webpack_public_path__ + "images/icon-rm-team-661a2fd2b48a75ed6d45637ce749cfe0.png";